module.exports = __webpack_public_path__ + "img/lavadora.6148b6b5.svg";